import { responseStatus } from '@app/constants/responseStatus'

import type { AxiosError } from 'axios'
import type { MultiStatusResponseDto } from '@app/api/dtos'

type HandleErrorFn = (error: AxiosError<MultiStatusResponseDto>) => void

export const handleMultiStatusError = (error: AxiosError<MultiStatusResponseDto>, onError: HandleErrorFn): void => {
  if (error.response?.status === responseStatus.MULTI_STATUS) {
    onError(error)
  }
}
